import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";

import { getEstimateHistory } from "services/estimate-history.service";
import { HistoryNotes, HistoryTimeline } from "./EstimateHistoryPanel";

// Estimate history as its own page (2026-10-24): /estimates/:id/history, where :id is the estimate id or the contract
// token from the estimate link (so a Podio field can point here). Staff login needed, like every page of the app.
function EstimateHistoryPage({ match }: any) {
  const key = match.params.id;
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getEstimateHistory(key).then(setData)
      .catch(e => setError(e?.response?.status === 404 ? "No estimate found for this link." : "Could not load the estimate history."));
  }, [key]);

  if (error) return <div style={{ padding: 24 }}>{error}</div>;
  if (!data) return <div style={{ padding: 24 }}>Loading the estimate history...</div>;
  const s = data.summary || {};
  return (
    <div style={{ maxWidth: 820, margin: "0 auto", padding: "8px 12px" }} data-testid="estimate-history-page">
      <div style={{ background: "#fff", borderLeft: "4px solid #1e88e5", boxShadow: "0 1px 3px rgba(0,0,0,0.12)", borderRadius: 4, padding: "12px 16px" }}>
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 2 }}>
          Estimate history · {data.customerName || "Estimate"} (#{data.estimateId})
        </div>
        {data.address && <div style={{ color: "#616161", fontSize: 14 }}>{data.address}</div>}
        <div style={{ fontSize: 15, margin: "8px 0", fontWeight: 600 }} data-testid="history-summary">{data.summaryLine}</div>
        <div style={{ fontSize: 13, color: "#616161", marginBottom: 6 }}>
          Status: {s.statusLabel}{s.priceNow ? ` · price now $${Number(s.priceNow).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ""} ·{" "}
          <Link to={`/estimates/${data.estimateId}/wizard`}>Open the estimate</Link> · Times are Central (CT)
        </div>
        <HistoryTimeline data={data} />
        <HistoryNotes data={data} />
      </div>
    </div>
  );
}

export default withRouter(EstimateHistoryPage);
